import {createSelector, createSlice, PayloadAction} from 'lowkey-component';

import {RootState} from '@store/rootReducer';

export type HeaderNavDisplayState = 'show' | 'hide' | undefined;

export interface NavState {
  isOpenGlobalNav: boolean;
  isShowHeaderNavMenu: boolean;
  headerNavDisplayState: HeaderNavDisplayState;
}

const initialValues: NavState = {
  isOpenGlobalNav: false,
  isShowHeaderNavMenu: false,
  headerNavDisplayState: 'show',
};

export const selectNavState = (state: RootState) => {
  return state.nav;
};

const selectIsOpenGlobalNav = createSelector(
  selectNavState,
  ({isOpenGlobalNav}) => isOpenGlobalNav,
);

const selectIsShowHeaderNavMenu = createSelector(
  selectNavState,
  ({isShowHeaderNavMenu}) => isShowHeaderNavMenu,
);

const selectHeaderNavDisplayState = createSelector(
  selectNavState,
  ({headerNavDisplayState}) => headerNavDisplayState,
);

const navSlice = createSlice({
  initialValues,
  reducers: {
    isOpenGlobalNavSaved: (state, action: PayloadAction<boolean>) => {
      state.isOpenGlobalNav = action.payload;
    },
    isShowHeaderNavMenuSaved: (state, action: PayloadAction<boolean>) => {
      state.isShowHeaderNavMenu = action.payload;
    },
    headerNavDisplaySaved: (
      state,
      action: PayloadAction<HeaderNavDisplayState>,
    ) => {
      state.headerNavDisplayState = action.payload;
    },
  },
});

export const navSelectors = {
  selectIsShowHeaderNavMenu,
  selectIsOpenGlobalNav,
  selectHeaderNavDisplayState,
};

export const {
  isShowHeaderNavMenuSaved,
  isOpenGlobalNavSaved,
  headerNavDisplaySaved,
} = navSlice.actions;

export const {getInitialValues} = navSlice;
export default navSlice.reducer;
